<template>
  <v-container>
    <v-row justify="center">
      <v-col
        max-width="1400"
        class="py-0"
      >
        <v-breadcrumbs
          :items="breadCrumbs"
          divider="/"
          class="pl-0 mx-4"
        />
      </v-col>
      <v-col
        v-if="archived"
        cols="12"
      >
        <v-card max-width="700">
          <v-card-title class="text-h4 font-weight-light">
            DIAS on arkistoinut tämän kaupan tiedot
          </v-card-title>
          <v-card-text>
            <p>
              Otathan yhteyttä
              <b>DIASin asiakaspalveluun</b> jos tarvitset apua kaupan tietojen kanssa:
              Puh. +358 10 201 1190 (puhelun hinta pvm / mpm), sähköposti: asiakaspalvelu@dias.fi
            </p>
          </v-card-text>
        </v-card>

        <v-card max-width="700" class="mt-4">
          <trade-attachments v-if="tradeId" :trade-id="tradeId"/>
        </v-card>
      </v-col>

      <v-col
        v-if="property && !archived"
        cols="12"
        max-width="1400"
        class="py-0"
        width="100%"
      >
        <v-row>
          <v-col class="py-0">
            <h1 class="text-h4 font-weight-light mb-1 mt-0 ml-2">
              Sähköinen kaupankäynti
            </h1>
          </v-col>
          <v-btn
            v-if="tradeDetails.data"
            icon
            class="mr-4"
            color="primary"
            @click="showDIASHelp = true"
          >
            <v-icon>help_outline</v-icon>
          </v-btn>
        </v-row>
        <v-row v-if="property" justify="center">
          <v-col
            cols="12"
            md="7"
            style="display: flex;flex-direction: column;"
          >
            <v-card
              outlined
              class="px-2 py-1 helmi-card"
              width="100%"
            >
              <v-card-text>
                <v-row align="center">
                  <v-col class="py-0 pb-1">
                    <div class="helmi-card-title mb-2 mt-3">
                      Edistyminen
                    </div>
                    <v-progress-linear
                      v-if="tradeDetails
                        && tradeDetails.data
                        && tradeDetails.data.tradeState
                        && tradeDetails.data.tradeState.tradePhase !== 'CANCELLED'"
                      v-model="progress"
                      buffer-value="0"
                      color="blue"
                      stream
                      class="mb-1 mt-2"
                    />
                    <p class="mt-1 helmi-font text-left mb-1">
                      Tila: <span class="font-weight-medium">{{ latestStatus }}</span>
                    </p>
                  </v-col>
                  <v-btn
                    v-if="tradeDetails.data"
                    icon
                    class="mr-4"
                    color="primary"
                    @click="showLoader();getTradeDetails()"
                  >
                    <v-icon>cached</v-icon>
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card
              outlined
              class="py-2 px-1 mt-6 helmi-card"
              width="100%"
              :style="$vuetify.breakpoint.mdAndUp ?
                `min-height:242px;
                display: flex;
                flex:1;
                justify-content: space-between;
                flex-direction: column;` : ''"
            >
              <v-card-text>
                <div class="helmi-card-title mb-2 mt-0 ml-1">
                  Dokumentit
                </div>

                <v-row>
                  <v-list class="mb-0" style="width:100%;">
                    <v-list-item
                      v-for="(document, idx) in sortedDocuments"
                      :key="idx"
                      @click="download(document)"
                    >
                      <v-list-item-avatar
                        class="mr-4"
                        :color="document.description === 'Liite' ? 'blue' : 'pink'"
                      >
                        <v-icon dark>
                          description
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-if="document.documentType">
                          {{ documentTypes
                            .find(d => d.documentType === document.documentType).description }}
                        </v-list-item-title>
                        <v-list-item-title v-else-if="document.description === 'Liite'">
                          Liite {{ idx > 0 ? idx : '' }}
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          Kauppakirja
                        </v-list-item-title>

                        <estate-attachment :document="document" :estates="estates"/>

                        <organization-attachment
                          :document="document"
                          :organizations="organizations"
                        />

                        <v-list-item-subtitle>
                          {{ document.filename }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action v-if="editable && document.description !== 'Kauppakirja'">
                        <div
                          v-if="editable && document.description === 'Liite'"
                          class="d-flex"
                          style="gap: 6px"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                color="primary"
                                small
                                v-bind="attrs"
                                v-on="on"
                                @click.stop="editDocument(document)"
                              >
                                <v-icon size="20">
                                  edit
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Muokkaa liitteen tyyppiä</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                color="primary"
                                small
                                v-bind="attrs"
                                v-on="on"
                                @click.stop="deleteDocument(document.id)"
                              >
                                <v-icon size="20">
                                  delete
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Poista liite</span>
                          </v-tooltip>
                        </div>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <template v-if="editable">
                    <v-alert
                      v-if="shareCertificateRequired"
                      type="warning"
                      text
                      color="red"
                      style="width:100%;"
                    >
                      Yhden liitteistä pitää olla tyypiltään osakekirja
                    </v-alert>
                    <v-alert
                      v-if="estateDeedsMissing"
                      type="warning"
                      text
                      color="red"
                      style="width:100%;"
                    >
                      Jokaista kuolinpesää kohden pitää liittää <b>perukirja</b>
                    </v-alert>

                    <v-alert
                      v-if="tradeRegisterExtractsMissing"
                      type="warning"
                      text
                      color="red"
                      style="width:100%;"
                    >
                      Jokaista yritysosapuolta kohden pitää liittää <b>kaupparekisteriote</b>
                    </v-alert>

                    <v-alert
                      v-if="shareInAttachments"
                      type="warning"
                      text
                      color="red"
                      style="width:100%;"
                    >
                      Muuta osakekirjan säilytyspaikaksi "myyjällä" jos osakekirja on liitteenä
                    </v-alert>
                    <v-alert
                      v-if="duplicates"
                      type="warning"
                      text
                      color="red"
                      style="width:100%;"
                    >
                      Liitteillä ei voi olla samaa tyyppiä
                    </v-alert>
                  </template>
                </v-row>
              </v-card-text>
              <upload v-if="editable" class="ma-2"/>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="5"
            style="
              display: flex;flex-direction: column;align-items: stretch;justify-content: stretch;"
          >
            <v-card
              v-if="property.apartment.shares"
              outlined
              class="pa-2 helmi-card"
              width="100%"
              max-width="1000"
            >
              <v-card-text class="pb-6">
                <div class="helmi-card-title mb-4 mt-n1">
                  Kaupan kohde
                </div>
                <v-row>
                  <v-col class="py-0">
                    Osoite: <b>{{ property.apartment.address.streetAddress }}
                    </b><br>
                    Postinumero: <b>{{ property.apartment.address.postalCode }}
                    </b><br>
                    Kaupunki: <b>{{ property.apartment.address.city }}
                    </b><br>
                    Taloyhtiö:
                    <b v-if="housingCompanyMissing" class="red--text">
                      Tiedot puuttuvat
                      <v-icon
                        color="red"
                        size="16"
                      >
                        error
                      </v-icon><br>
                    </b>
                    <template v-else>
                      <b>{{ property.apartment.housingCompany.name }},
                        {{ property.apartment.housingCompany.businessId }}
                      </b><br>
                    </template>
                    Osakenumerot: <b>{{ property.apartment.shares.join(', ') }}</b><br>

                    <template v-if="property.apartment?.osakeryhmatunnukset?.length">
                      Osakeryhmätunnukset:
                      <b v-if="property.apartment.osakeryhmatunnukset.length">
                        {{ property.apartment.osakeryhmatunnukset.join(', ') }}</b>
                      <b v-else-if="property.apartment.sharesType === 'DIGITAL'" class="red--text">
                        Tietoja puuttuu
                        <v-icon
                          color="red"
                          size="16"
                        >
                          error
                        </v-icon>
                      </b>

                      <br>
                    </template>

                    <template v-else-if="tradeDetails.data">
                      Osakekirjan sijainti: <b
                        v-if="tradeDetails
                          .data.sellerShareCertificateStatus ===
                          'ONE_OF_SELLERS_HAS_SHARE_CERTIFICATE'"
                      >
                        Myyjällä
                      </b><b
                        v-else-if="tradeDetails
                          .data.sellerShareCertificateStatus ===
                          'SELLER_BANK_HAS_SHARE_CERTIFICATE'"
                      >
                        Myyjän pankilla
                      </b>
                      <b v-else>Ei tiedossa</b><br>
                    </template>
                    <template v-else>
                      Osakekirjan sijainti: <b class="primary--text">
                        {{ shareCertificateLocationText }}</b><br>
                    </template>
                    Allekirjoitettava viimeistään:
                    <b v-if="tradeDetails.data && tradeDetails.data.deadlineForSigningBillOfSale">
                      {{ tradeDetails.data.deadlineForSigningBillOfSale | date }}
                      klo {{ tradeDetails.data.deadlineForSigningBillOfSale
                        | date({ type: 'time' }) }}
                    </b>
                    <b v-else-if="deadlineForSigningBillOfSale" class="primary--text">
                      {{ deadlineForSigningBillOfSale | date }}
                      klo {{ deadlineForSigningBillOfSaleTime }}
                    </b>
                    <b v-else class="primary--text">
                      Ei rajoitettu
                    </b><br>
                    Rahoitus:
                    <template v-if="tradeDetails.data">
                      <b
                        v-if="tradeDetails.data?.buyersMortgageStatus === 'MORTGAGE'"
                        class="primary--text"
                      >
                        Kohde on menossa lainan vakuudeksi
                      </b>

                      <b
                        v-else-if="tradeDetails.data?.buyersMortgageStatus === 'NO_MORTGAGE'"
                        class="primary--text"
                      >
                        Yhdelläkään ostajalla ei ole lainaa
                      </b>

                      <b v-else class="primary--text">Kohde on menossa lainan vakuudeksi</b>
                    </template>

                    <template v-else>
                      <b v-if="buyersMortgageStatus === 'MORTGAGE'" class="primary--text">
                        Kohde on menossa lainan vakuudeksi
                      </b>

                      <b v-else-if="buyersMortgageStatus === 'NO_MORTGAGE'" class="primary--text">
                        Yhdelläkään ostajalla ei ole lainaa
                      </b>
                    </template>

                    <v-alert
                      v-if="buyersMortgageStatus === 'NO_MORTGAGE' ||
                      tradeDetails.data?.buyersMortgageStatus === 'NO_MORTGAGE'"
                      type="info"
                      dense
                      class="mt-2 caption"
                      text
                    >
                      <template v-if="property.buyers?.length === 1">
                        Olet valinnut, että ostajalle ei tule rahoitusta pankista.
                        Käynnistäessäsi kaupan vahvistat, että noudatat voimassa olevia
                        rahanpesun ja terrorismin rahoituksen estämisen lakeja sekä
                        kiinteistönvälitysalan ohjeistuksia ja olet toteuttanut tarvittavat
                        menettelyt varojen alkuperän selvittämiseksi ja asiakkaan tuntemiseksi
                        taataksesi asuntokaupan lainmukaisuuden ja turvallisuuden.
                      </template>

                      <template v-else-if="property.buyers?.length > 1">
                        Olet valinnut, että yhdellekään ostajalle ei tule rahoitusta pankista.
                        Käynnistäessäsi kaupan vahvistat, että noudatat voimassa olevia rahanpesun
                        ja terrorismin rahoituksen estämisen lakeja sekä kiinteistönvälitysalan
                        ohjeistuksia ja olet toteuttanut tarvittavat menettelyt varojen alkuperän
                        selvittämiseksi ja asiakkaiden tuntemiseksi taataksesi asuntokaupan
                        lainmukaisuuden ja turvallisuuden.
                      </template>
                    </v-alert>
                  </v-col>
                  <v-btn
                    v-if="editable"
                    icon
                    class="mr-5"
                    @click="sellerShareLocationDialog = true"
                  >
                    <v-icon color="primary">
                      create
                    </v-icon>
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              outlined
              class="pa-2 mt-6 helmi-card"
              width="100%"
              max-width="1000"
            >
              <v-card-text class="pb-6">
                <div class="helmi-card-title mb-4 mt-n1">
                  Kaupan aloittava välittäjä
                </div>
                <v-row>
                  <v-col class="py-0">
                    Välittäjän nimi: <b class="mr-4 primary--text">
                      {{ currentAgent.nimi }}
                    </b><br>
                    Välittäjän sähköposti: <b>
                      {{ currentAgent.email }}
                    </b><br>
                    Välittäjän puhelinnumero: <b>{{ currentAgent.puhelin }}</b><br>
                  </v-col>
                  <v-btn
                    v-if="editable"
                    icon
                    class="mr-5"
                    @click="editAgentDialog = true"
                  >
                    <v-icon color="primary">
                      create
                    </v-icon>
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              v-if="property.companyBankAccounts"
              outlined
              class="pa-2 mt-6 fill-height helmi-card"
              width="100%"
              max-width="1000"
            >
              <v-card-text>
                <div class="helmi-card-title mb-2 mt-n1">
                  Välityspalkkion tiedot
                </div>
                Välityspalkkio:
                <b v-if="!tradeDetails.data" class="mr-4">
                  {{ initialTotalRealtorPayment / 100 | currency }}
                </b>
                <b v-else>
                  {{ totalRealtorPayment / 100 | currency }}
                </b>
                <br>
                Viitenumero: <b>{{ property.sellers[0].realtorPayment
                  && property.sellers[0].realtorPayment.referenceNumber }}</b><br>
                IBAN: <b>{{ property.companyBankAccounts[0].iban }}</b><br>
                BIC: <b>{{ property.companyBankAccounts[0].bic }}</b>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card
              outlined
              class="pa-2 fill-height helmi-card"
              width="100%"
              max-width="1000"
            >
              <v-card-text>
                <div class="helmi-card-title mb-4 mt-0">
                  Myyjät
                </div>

                <v-alert
                  v-if="totalRealtorPaymentDoesNotMatch"
                  type="warning"
                  class="mb-6"
                  text
                  color="red"
                >
                  {{ totalRealtorPaymentDoesNotMatch }}
                </v-alert>

                <sellers-preview
                  v-if="!editable && tradeSellers.length"
                  :sellers="tradeSellers"
                  :banks="banks"
                />

                <template v-else>
                  <div
                    v-for="(seller, idx) in property.sellers"
                    :key="idx"
                    outlined
                    class="mb-4"
                  >
                    <v-row align="start">
                      <v-col class="pt-1">
                        <template
                          v-if="seller.roles"
                        >
                          <b>{{
                        seller.roles?.map(role => {
                            const roles = {
                              ORGANIZATION: 'Yritys',
                              ORGANIZATION_SIGNER: 'Yrityksen edustaja',
                              SIGNER: 'Myyjä',
                              ESTATE: 'Kuolinpesä',
                              ESTATE_SIGNER: 'Kuolinpesän edustaja',
                            }

                            return roles[role];
                          }).join(', ') || 'Suostumuksen antaja'
                          }}</b>
                          <br>
                        </template>

                        <template v-if="seller.organization">
                          <participant-detail
                            title="Nimi"
                            :value="seller.organization.name"
                          />

                          <participant-detail
                            title="VAT-tunnus"
                            :value="seller.organization.businessId"
                          />
                        </template>

                        <template v-else>
                          <participant-detail title="Etunimi" :value="seller.person?.firstName"/>

                          <participant-detail title="Sukunimi" :value="seller.person?.lastName"/>

                          <participant-detail
                            title="Henkilötunnus"
                            :value="seller.person.socialSecurityNumber"
                          />

                          <participant-detail
                            v-if="!seller.roles?.some(role => role === 'ESTATE')"
                            title="Sähköposti"
                            :value="seller.person.email"
                          />
                        </template>

                        <participant-detail
                          v-if="seller.roles?.some(role => role === 'ORGANIZATION_SIGNER')"
                          title="Edustaa yrityksiä"
                          :value="seller.businessIds?.map(
                          businessId => getCompanyName(businessId)).join(', ')"
                        />

                        <participant-detail
                          v-if="seller.roles?.some(role => role === 'ESTATE_SIGNER')"
                          title="Edustaa kuolinpesiä"
                          :value="seller.person?.estates?.split(',')
                          .map(estate => getEstateName(estate)).join(', ')"
                        />

                        <participant-detail
                          v-if="seller.roles?.some(role => role !== 'ESTATE_SIGNER') &&
                          seller.roles?.some(role => ['SIGNER', 'ORGANIZATION', 'ESTATE']
                          .includes(role))"
                          title="Maksaa välityspalkkiota"
                          :value="!seller.realtorPaymentPerSellerInCents ? 'Ei' :
                            ($filters.currency(seller.realtorPaymentPerSellerInCents / 100))"
                        />

                        <template
                          v-if="['ORGANIZATION', 'SIGNER', 'ESTATE']
                            .some(role => (seller.roles || []).includes(role))"
                        >
                          Pankki: <b
                            v-if="
                            seller.person?.bankBusinessId || seller.bankBusinessId"
                          >
                            {{ getBankName(seller.person?.bankBusinessId ||
                            seller.bankBusinessId) }}</b>
                          <span v-else class="red--text">
                            Ei valittu
                            <v-icon
                              color="red"
                              size="16"
                            >
                              error
                            </v-icon>
                          </span>
                        </template>
                      </v-col>
                      <v-btn
                        v-if="editable"
                        icon
                        class="mr-5 edit-seller"
                        @click="edit(seller);editingSeller = true;"
                      >
                        <v-icon color="primary">
                          create
                        </v-icon>
                      </v-btn>
                    </v-row>
                  </div>
                </template>
                <v-alert
                  v-if="sellersShouldPayComission"
                  type="warning"
                  text
                  color="red"
                  style="width:100%;"
                >
                  Ainakin yhden myyjän pitäisi maksaa välityspalkkiota
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card
              outlined
              class="pa-2 fill-height helmi-card"
              width="100%"
              max-width="1000"
            >
              <v-card-text>
                <div class="helmi-card-title mb-4 mt-0">
                  Ostajat
                </div>

                <buyers-preview
                  v-if="!editable && tradeBuyers.length"
                  :buyers="tradeBuyers"
                  :banks="banks"
                />

                <template v-else>
                  <div
                    v-for="(buyer, idx) in property.buyers"
                    :key="idx"
                    outlined
                    class="mb-4"
                  >
                    <v-row align="start">
                      <v-col class="pt-1">
                        <template
                          v-if="buyer.roles"
                        >
                          <b>{{
                        buyer.roles?.map(role => {
                            const roles = {
                              ORGANIZATION: 'Yritys',
                              ORGANIZATION_SIGNER: 'Yrityksen edustaja',
                              SIGNER: 'Ostaja',
                            }

                            return roles[role];
                          }).join(', ')
                          }}</b>
                          <br>
                        </template>

                        <template v-if="!buyer.roles?.includes('ORGANIZATION')">
                          <participant-detail
                            title="Etunimi"
                            :value="buyer.person?.firstName"
                          />

                          <participant-detail
                            title="Sukunimi"
                            :value="buyer.person?.lastName"
                          />

                          <participant-detail
                            title="Henkilötunnus"
                            :value="buyer.person?.socialSecurityNumber"
                          />

                          <participant-detail
                            title="Sähköposti"
                            :value="buyer.person?.email"
                          />

                          <participant-detail
                            v-if="buyer.roles?.some(role => role === 'ORGANIZATION_SIGNER')"
                            title="Edustaa yrityksiä"
                            :value="buyer.businessIds?.map(
                            businessId => getCompanyNameBuyers(businessId)).join(', ')"
                          />
                        </template>

                        <template v-else>
                          <participant-detail
                            title="Yrityksen nimi"
                            :value="buyer.organization.name"
                          />

                          <participant-detail
                            title="VAT-numero"
                            :value="buyer.organization.businessId"
                          />
                        </template>

                        <template v-if="buyer.person?.transfertax">
                          Omistusosuus:
                          <b>{{ buyer.person.share }}/{{ buyer.person.divider }}</b><br>
                          Vapautettu varainsiirtoveron maksamisesta:
                          <b>{{ +buyer.person.transfertax === 1 ? 'Ei' : 'Kyllä' }}</b>
                          <template v-if="+buyer.transfertax === 1">
                            <br>
                            <span>
                              Varainsiirtoveron määrä: <b>{{ tax(buyer.person) | currency }}</b>
                            </span>
                          </template>
                          <br>
                        </template>
                        Pankki: <b v-if="buyer.person?.bankBusinessId">
                          {{ getBankName(buyer.person.bankBusinessId) }}
                        </b>
                        <span v-else class="red--text">
                          Ei valittu
                          <v-icon
                            color="red"
                            size="16"
                          >
                            error
                          </v-icon>
                        </span>
                      </v-col>
                      <v-btn
                        v-if="editable"
                        icon
                        class="mr-5 edit-buyer"
                        @click="edit(buyer);editingSeller = false;"
                      >
                        <v-icon color="primary">
                          create
                        </v-icon>
                      </v-btn>
                    </v-row>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-col>

          <v-alert
            v-if="inputError"
            type="warning"
            class="mx-4"
            text
            color="red"
            style="width:100%;"
          >
            {{ inputError }}
          </v-alert>

          <v-card
            color="transparent"
            class="pa-2 mt-0 mx-0 elevation-0"
            width="100%"
          >
            <div class="d-flex flex-column flex-md-row align-stretch gap justify-end px-1">
              <v-btn
                v-if="!tradeDetails.data"
                depressed
                color="primary"
                large
                :disabled="detailsMissing
                  || shareCertificateRequired
                  || sellersShouldPayComission
                  || duplicates || shareInAttachments || housingCompanyMissing"
                @click="showConfirmation = true"
              >
                Aloita kauppa
                <v-icon>chevron_right</v-icon>
              </v-btn>

              <v-btn
                v-if="tradeDetails.data && showCancel"
                depressed
                color="red"
                large
                dark
                @click="cancelDialog = true"
              >
                Keskeytä kauppa
                <v-icon>clear</v-icon>
              </v-btn>

              <v-btn
                v-if="tradeDetails
                  && tradeDetails.data
                  && tradeDetails.data.tradeState
                  && tradeDetails.data.tradeState.tradePhase === 'BUYER_BANK_APPROVED'"
                depressed
                large
                color="primary"
                @click="startSigning()"
              >
                Aloita allekirjoittaminen
                <v-icon>chevron_right</v-icon>
              </v-btn>

              <v-btn
                v-if="vsvAvailable"
                depressed
                large
                color="primary"
                @click="goToTaxTransfer()"
              >
                Siirry varainsiirtoveron ilmoittamiseen
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </div>

            <v-alert
              v-if="tradeDetails
                && tradeDetails.data
                && tradeDetails.data.tradeState
                && tradeDetails.data.tradeState.tradePhase === 'CANCELLED'"
              prominent
              type="error"
            >
              <v-row align="center">
                <v-col class="grow">
                  Kauppa keskeytetty. Nollaa ja palaa kauppakirjalle aloittaaksesi
                  DIAS-kauppa uudelleen.
                </v-col>
                <v-col class="shrink">
                  <v-btn
                    outlined
                    large
                    color="white"
                    @click="cancel(true)"
                  >
                    Nollaa & Palaa
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </v-card>
        </v-row>
        <template v-if="tradeDetails.data">
          <v-card
            outlined
            class="pa-2 mt-6 helmi-card"
            width="100%"
          >
            <v-card-text>
              <div class="helmi-card-title mb-3 mt-0">
                Asiakirjat
              </div>

              <v-list class="mb-0">
                <v-list-item
                  :disabled="!signedBillAvailable"
                  class="pl-1"
                  @click="download({ dias_id: tradeDetails.data.tradeState
                    .signingComplete.billOfSaleSigned.id })"
                >
                  <v-list-item-avatar
                    class="mr-4"
                    :color="signedBillAvailable ? 'blue' : 'grey'"
                  >
                    <v-icon dark>
                      description
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      Allekirjoitettu kauppakirja
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="signedBillAvailable">
                      Allekirjoitettu {{ formatTimeStamp(tradeDetails.data.tradeState
                        .signingComplete.signedTimestamp) }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else class="grey--text">
                      Ei saatavilla
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="property.apartment && property.apartment.sharesType !== 'DIGITAL'"
                  class="pl-1"
                  :disabled="!ownershipTransferDocumentAvailable"
                  @click="download({ dias_id:
                    tradeDetails.data.ownershipTransferPowerOfAttorney.id })"
                >
                  <v-list-item-avatar
                    class="mr-4"
                    :color="ownershipTransferDocumentAvailable ? 'blue' : 'grey'"
                  >
                    <v-icon dark>
                      description
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      Siirtomerkinnän valtakirja
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-if="!ownershipTransferDocumentAvailable"
                      class="grey--text"
                    >
                      Ei saatavilla
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <template v-for="(buyer, idx) in tradeDetails.data && tradeDetails.data.buyers">
                  <v-list-item
                    v-if="buyer.transferTax"
                    :key="idx"
                    :disabled="!buyer.transferTax.receipt"
                    class="pl-1"
                    @click="download({ dias_id: buyer.transferTax.receipt.id })"
                  >
                    <v-list-item-avatar
                      class="mr-4"
                      :color="buyer.transferTax.receipt ? 'blue' : 'grey'"
                    >
                      <v-icon dark>
                        description
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content v-if="buyer.transferTax.receipt">
                      <v-list-item-title>
                        {{ buyer.transferTax.receipt.description }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Vahvistettu: {{ formatTimeStamp(buyer.transferTax.confirmedTimestamp) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                      <v-list-item-title>
                        Kuitti varainsiirtoveron maksusta
                        ({{ buyer.person?.firstName }} {{ buyer.person?.lastName }})
                      </v-list-item-title>
                      <v-list-item-subtitle class="grey--text">
                        Ei saatavilla
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <v-list-item
                  v-if="property.apartment && property.apartment.sharesType !== 'DIGITAL'"
                  class="pl-1"
                  :disabled="!certificateExists"
                  @click="download({ dias_id: tradeDetails.data.tradeState
                    .shareCertificate.certificate.id })"
                >
                  <v-list-item-avatar
                    class="mr-4"
                    :color="certificateExists ? 'blue' : 'grey'"
                  >
                    <v-icon dark>
                      description
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      Skannattu osakekirja
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="certificateExists">
                      Siirto vahvistettu {{ formatTimeStamp(tradeDetails.data.tradeState
                        .shareCertificate.transferConfirmedTimestamp) }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else class="grey--text">
                      Ei saatavilla
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
          <events :trade-details="tradeDetails"/>
        </template>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="500">
      <v-card class="helmi-card">
        <div class="helmi-card-title pt-6 pb-4 pl-6">
          Muokkaa tietoja
        </div>
        <v-card-text class="pb-0">
          <template v-if="!editedItem.roles?.includes('ORGANIZATION') && editedItem.person">
            <v-text-field v-model="editedItem.person.firstName" label="Etunimi"/>

            <v-text-field v-model="editedItem.person.lastName" label="Sukunimi"/>

            <v-text-field
              id="edit-ssn"
              v-model="editedItem.person.socialSecurityNumber"
              :disabled="editedItem.roles?.includes('ESTATE')"
              label="Henkilötunnus"
            />

            <v-text-field
              v-if="+editedItem.person.role !== 4"
              v-model="editedItem.person.email"
              label="Sähköposti"
            />
          </template>

          <template v-if="editedItem.roles?.includes('ORGANIZATION')">
            <v-text-field
              v-model="editedItem.organization.name"
              label="Yrityksen nimi"
            />

            <v-text-field
              v-model="editedItem.organization.businessId"
              disabled
              label="VAT-tunnus"
            />
          </template>

          <template
            v-if="
              editedItem.roles?.includes('SIGNER') ||
            editedItem.roles?.includes('ORGANIZATION') ||
            editedItem.roles?.includes('ESTATE')"
          >
            <v-text-field
              v-if="editedItem.realtorPayment"
              v-model="editedAmountInEuros"
              class="mb-4"
              label="Välityspalkkion osuus"
              persistent-hint
              :hint="
                `Kokonaisvälityspalkkio: ${$filters
                  .currency(editedItem.realtorPayment.amountInCents / 100)}`"
              type="number"
              @input="editedItem.realtorPaymentPerSellerInCents =
                Math.round(editedAmountInEuros * 100)"
            />

            <v-autocomplete
              v-model="editedItem.person.bankBusinessId"
              :items="banks"
              label="Pankki"
              item-value="businessId"
              item-text="combName"
              :hint="editingSeller ? 'Huom! Valinta vaihtaa kaikkien myyjien pankin'
                : 'Huom! Valinta vaihtaa kaikkien ostajien pankin'"
              persistent-hint
              @change="editingSeller ? setAllSellersBank(editedItem.person.bankBusinessId)
                : setAllBuyersBank(editedItem.person.bankBusinessId)"
            />
          </template>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            color="primary"
            @click="dialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="sellerShareLocationDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title>Kaupan tiedot</v-card-title>
        <v-card-text class="pb-0">
          <v-form
            ref="deadlineForm"
            v-model="deadlineFormValid"
          >
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="deadlineForSigningBillOfSale"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="$options.filters.date(deadlineForSigningBillOfSale)"
                  label="Allekirjoitettava viimeistään (pvm)"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="deadlineForSigningBillOfSale"
                locale="fi-fi"
                :first-day-of-week="1"
                no-title
                scrollable
              >
                <v-spacer/>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Peruuta
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="deadlineForSigningBillOfSale = null"
                >
                  Poista valinta
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(deadlineForSigningBillOfSale)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
            <v-text-field
              v-if="deadlineForSigningBillOfSale"
              v-model="deadlineForSigningBillOfSaleTime"
              :rules="[rules.time]"
              label="Allekirjoitettava viimeistään (klo)"
            />

            <v-select
              v-if="property"
              v-model="shareLocation"
              :items="shareLocations"
              :disabled="property.apartment.sharesType === 'DIGITAL'"
              label="Osakekirjan sijainti"
            />

            <v-select
              v-if="property"
              v-model="buyersMortgageStatus"
              :items="buyersMortgageStatuses"
              label="Rahoitus"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            :disabled="!deadlineFormValid"
            depressed
            color="primary"
            @click="sellerShareLocationDialog = false; storeMortgageStatus();"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editDocumentDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title>Liitteen tyyppi</v-card-title>

        <v-card-text class="pb-0">
          <v-select
            v-model="currentDocument.documentType"
            :items="documentTypes"
            item-text="description"
            item-value="documentType"
            label="Liitteen tyyppi"
          />

          <estate-selection
            v-if="showEstateSelection"
            :selected-estate="currentDocument.estateSocialSecurityNumber"
            :estates="estates"
            @change="(val) => { currentDocument.estateSocialSecurityNumber = val; }"
          />

          <organization-selection
            v-if="showOrganizationSelection"
            :selected-organization="currentDocument.businessId"
            :organizations="organizations"
            @change="(val) => { currentDocument.businessId = val; }"
          />
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            :disabled="
              (showEstateSelection && !currentDocument.estateSocialSecurityNumber) ||
                (showOrganizationSelection && !currentDocument.businessId)"
            color="primary"
            @click="applyDocument()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editAgentDialog" max-width="500">
      <v-card>
        <v-card-title>Valitse välittäjä</v-card-title>
        <v-card-text class="pb-0">
          <v-select
            v-model="currentAgent"
            :items="agents"
            item-text="nimi"
            return-object
            label="Välittäjä"
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            color="primary"
            @click="editAgentDialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelDialog" max-width="500">
      <v-card>
        <v-card-title>Keskeytä kauppa</v-card-title>
        <v-card-text class="pb-0">
          <v-text-field
            v-model="cancelReason"
            label="Keskeytyksen syy"
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            color="primary"
            @click="cancelDialog = false"
          >
            Peruuta
          </v-btn>
          <v-btn
            depressed
            color="primary"
            @click="cancel()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDIASHelp" max-width="500">
      <v-card>
        <v-card-title>Tarvitsetko apua?</v-card-title>
        <v-card-text>
          Apua DIAS-kaupan mahdollisten ongelmatilanteiden ratkaisemiseen löydät
          <a href="https://asiakaspalvelu.dias.fi/hc/fi" target="_blank">
            DIASin asiakaspalvelun tukiportaalista
          </a>.
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            color="primary"
            @click="showDIASHelp = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirmation
      title="Kaupan aloitus"
      submit-text="Aloita kauppa"
      :show="showConfirmation"
      :valid="emailIsValidBoolean"
      @cancel="showConfirmation = false"
      @submit="sendToDias()"
    >
      <v-checkbox
        v-model="automaticSigningProcess"
        dense
        hide-details
        class="mb-4"
        label="Aloita allekirjoitusvaihe automaattisesti pankkien hyväksynnän jälkeen"
      />

      <v-checkbox
        v-model="sendEmail"
        dense
        label="Lähetä kaikki kaupan liitteet automaattisesti isännöitsijälle kaupan valmistuttua"
      />

      <v-text-field
        v-if="sendEmail"
        v-model="email"
        :rules="[emailIsValid]"
        label="Isännöitsijän sähköposti"
      />
    </confirmation>

    <v-overlay
      :value="connectionFailure"
      color="white"
      opacity="0.95"
    >
      <v-col class="text-center">
        <v-icon color="primary lighten-2" size="180">
          error
        </v-icon>
        <p class="mb-6 mt-2 black--text text-center">
          DIAS ei ole tilapäisesti käytettävissä.<br>Yritäthän myöhemmin uudelleen.
        </p>
        <v-btn
          class="px-4"
          color="primary"
          rounded
          outlined
          @click="goToStart()"
        >
          <v-icon class="mr-1">
            keyboard_backspace
          </v-icon>
          Takaisin
        </v-btn>
      </v-col>
    </v-overlay>
  </v-container>
</template>
<script>
import download from 'downloadjs'; // eslint-disable-line
import { mapGetters, mapActions, mapState } from 'vuex';
import { apiGet, apiPost } from '../../api';

export default {
  components: {
    confirmation: () => import('@/components/Confirmation.vue'),
    upload: () => import('@/components/DIAS/DIASUpload.vue'),
    events: () => import('@/components/DIAS/DIASEvents.vue'),
    'participant-detail': () => import('@/components/DIAS/DIASParticipantDetail.vue'),
    'estate-selection': () => import('@/components/DIAS/DIASEstateSelection.vue'),
    'organization-selection': () => import('@/components/DIAS/DIASOrganizationSelection.vue'),
    'estate-attachment': () => import('@/components/DIAS/DIASEstateAttachment.vue'),
    'organization-attachment': () => import('@/components/DIAS/DIASOrganizationAttachment.vue'),
    'sellers-preview': () => import('@/components/DIAS/DIASSellersPreview.vue'),
    'buyers-preview': () => import('@/components/DIAS/DIASBuyersPreview.vue'),
    TradeAttachments: () => import('@/components/TradeAttachments.vue'),
  },
  data: () => ({
    archived: false,
    showConfirmation: false,
    property: null,
    documents: [],
    sendEmail: false,
    connectionFailure: false,
    tradeId: null,
    email: '',
    menu: false,
    editingSeller: false,
    currentDocument: {},
    tradeSellers: [],
    tradeBuyers: [],
    showDIASHelp: false,
    cancelDialog: false,
    cancelReason: '',
    deadlineForSigningBillOfSale: null,
    dialog: false,
    inputError: null,
    sellerShareLocationDialog: false,
    automaticSigningProcess: true,
    deadlineForSigningBillOfSaleTime: '12:00',
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      time: (value) => {
        const pattern = /^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/;
        return pattern.test(value) || 'Virheellinen kellonaika (hh:mm).';
      },
    },
    agents: [],
    editable: true,
    currentAgent: {},
    editedItem: {},
    deadlineFormValid: false,
    editedAmountInEuros: 0,
    tries: 0,
    banks: [],
    tradeDetails: {},
    editDocumentDialog: false,
    editAgentDialog: false,
    buyersMortgageStatus: 'MORTGAGE',
    buyersMortgageStatuses: [
      {
        text: 'Kohde on menossa lainan vakuudeksi',
        value: 'MORTGAGE',
      },
      {
        text: 'Yhdelläkään ostajalla ei ole lainaa',
        value: 'NO_MORTGAGE',
      },
    ],
    shareLocation: 'UNKNOWN',
    shareLocations: [
      {
        text: 'Myyjällä',
        value: 'ONE_OF_SELLERS_HAS_SHARE_CERTIFICATE',
      },
      {
        text: 'Myyjän pankilla',
        value: 'SELLER_BANK_HAS_SHARE_CERTIFICATE',
      },
      {
        text: 'Ei tiedossa',
        value: 'UNKNOWN',
      },
    ],
  }),
  computed: {
    ...mapState({
      currentProperty: state => state.currentProperty,
      taxDetails: state => state.taxDetails,
    }),

    emailIsValid() {
      if (!this.sendEmail) return true;

      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return pattern.test(this.email) || 'Virheellinen sähköpostiosoite';
    },

    emailIsValidBoolean() {
      if (!this.sendEmail) return true;

      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return pattern.test(this.email);
    },

    ...mapGetters({
      userDetails: 'userDetails',
    }),

    documentTypes() {
      let documentTypes = [
        {
          description: 'Ei valintaa',
          documentType: '',
        },
        {
          description: 'Osakekirja',
          documentType: 'SHARE_CERTIFICATE',
        },
        {
          description: 'Puolison suostumus',
          documentType: 'SPOUSES_CONSENT',
        },
        {
          description: 'Isännöitsijäntodistus',
          documentType: 'HOUSE_MANAGERS_CERTIFICATE',
        },
        {
          description: 'Osakehuoneistotuloste',
          documentType: 'OWNER_APARTMENT_PRINTOUT',
        },
      ];

      if (this.estates.length) {
        documentTypes = [...documentTypes, {
          description: 'Perukirja',
          documentType: 'ESTATE_INVENTORY_DEED',
        }, {
          description: 'Perukirjan liite',
          documentType: 'ESTATE_INVENTORY_DEED_ATTACHMENT',
        },
        {
          description: 'DVVn vahvistama osakasluettelo',
          documentType: 'ESTATE_INVENTORY_DEED_SHAREHOLDERS_CERTIFICATION',
        },
        ];
      }

      if (this.organizationsLength > 0) {
        documentTypes = [...documentTypes, {
          description: 'Kaupparekisteriote',
          documentType: 'TRADE_REGISTER_EXTRACT',
        }, {
          description: 'Pöytäkirjaote',
          documentType: 'MINUTES_EXTRACT',
        }];
      }

      return documentTypes;
    },

    vsvAvailable() {
      return this.tradeDetails?.data?.events?.some(e => e.tradePhase === 'BUYER_BANK_PAYMENTS_COMPLETED');
    },

    deadlineIso() {
      const date = this.deadlineForSigningBillOfSale;
      if (!date) return '';
      const time = this.deadlineForSigningBillOfSaleTime;
      return new Date(`${date} ${time}`).toISOString();
    },

    totalRealtorPayment() {
      let amountInCents = 0;
      this.property.sellers.forEach((seller) => {
        if (seller.realtorPayment) {
          amountInCents += seller.realtorPayment.amountInCents;
        }
      });
      return amountInCents;
    },

    showCancel() {
      const cancelPhases = [
        'INITIATED',
        'SELLER_BANK_APPROVED',
        'BUYER_BANK_APPROVED',
        'INITIATOR_SIGNING_CONFIRMATION_RECEIVED',
      ];
      return cancelPhases.includes(this.tradeDetails.data.tradeState.tradePhase);
    },

    housingCompanyMissing() {
      return this.property.apartment.housingCompany.businessId === 'FI';
    },

    sellersShouldPayComission() {
      if (!this.property.sellers) {
        return false;
      }
      return this.property.sellers[0].realtorPayment
        && this.property.sellers[0].realtorPayment.amountInCents > 0
        && !this.property.sellers.some(s => !s.doesNotPay);
    },

    duplicates() {
      if (this.tradeDetails.data) return false;
      if (this.documents.filter(d => d.documentType === 'SHARE_CERTIFICATE').length > 1) return true;
      if (this.documents.filter(d => d.documentType === 'SPOUSES_CONSENT').length > 1) return true;
      if (this.documents.filter(d => d.documentType === 'HOUSE_MANAGERS_CERTIFICATE').length > 1) return true;
      return false;
    },

    initialTotalRealtorPayment() {
      return this.property.sellers.find(s => s.realtorPayment?.
        amountInCents > 0)?.realtorPayment.amountInCents || 0;
    },

    estates() {
      return this.property?.sellers.filter(seller => seller.roles.includes('ESTATE')) || [];
    },

    estateDeedsMissing() {
      return !this.estates.every(estate => this.documents
        .some(d => d.documentType === 'ESTATE_INVENTORY_DEED'
          && d.estateSocialSecurityNumber === estate.person.socialSecurityNumber));
    },

    organizationsLength() {
      return this.organizations.length;
    },

    organizations() {
      const organizationSellers = this.sellersPayload.filter(s => s.organization);
      const organizationBuyers = this.buyersPayload.filter(s => s.organization);

      return [...organizationSellers, ...organizationBuyers];
    },

    tradeRegisterExtractsMissing() {
      const registerExtractsCount = this.documents
        .filter(d => d.documentType === 'TRADE_REGISTER_EXTRACT').length;

      if (registerExtractsCount < this.organizationsLength) {
        return true;
      }

      return false;
    },

    sellersPayload() {
      if (!this.property?.sellers) return [];

      if (this.tradeSellers.length) {
        return this.tradeSellers;
      }

      return this.property.sellers
        .filter(seller => seller.roles.length > 0)
        .map((s) => {
          const realtorPaymentPerSeller = {
            referenceNumber: s.realtorPayment?.referenceNumber,
            amountInCents: s.realtorPaymentPerSellerInCents,
          };

          if (s.person.role === 'COMPANY') {
            const company = {
              roles: s.roles,
              organization: s.organization,
              bankBusinessId: s.person.bankBusinessId,
              realtorPayment: realtorPaymentPerSeller,
            };

            if (+(s.realtorPaymentPerSellerInCents || 0) === 0) {
              delete company.realtorPayment;
            }

            return company;
          }
          const seller = {
            roles: s.roles,
            person: {
              email: s.person.email,
              socialSecurityNumber: s.person.socialSecurityNumber,
              firstName: s.person.firstName,
              lastName: s.person.lastName,
            },
          };

          if (seller.roles.includes('SIGNER')) {
            seller.bankBusinessId = s.person.bankBusinessId;
            seller.realtorPayment = realtorPaymentPerSeller;
          }

          if (seller.roles.includes('ORGANIZATION_SIGNER')) {
            seller.businessIds = s.businessIds;
          }

          if (seller.roles.includes('ESTATE')) {
            seller.bankBusinessId = s.person.bankBusinessId;
            seller.realtorPayment = realtorPaymentPerSeller;

            delete seller.person.email;
          }

          if (seller.roles.includes('ESTATE_SIGNER')) {
            const estates = s.person?.estates?.length > 0 ? s.person.estates.split(',') : [];

            seller.estateSocialSecurityNumbers = this.estates
              .filter(estate => estates.includes(estate.person.id))
              .map(estate => estate.person.socialSecurityNumber);
          }

          if (+(s.realtorPaymentPerSellerInCents || 0) === 0) {
            delete seller.realtorPayment;
          }

          return seller;
        });
    },

    showEstateSelection() {
      return [
        'ESTATE_INVENTORY_DEED',
        'ESTATE_INVENTORY_DEED_ATTACHMENT',
        'ESTATE_INVENTORY_DEED_SHAREHOLDERS_CERTIFICATION',
      ].includes(this.currentDocument.documentType);
    },

    totalRealtorPaymentDoesNotMatch() {
      if (this.tradeDetails.data) return false;

      const countedAmountInCents = this.sellersPayload
        .filter(s => s.realtorPayment?.amountInCents > 0)
        .map(s => s.realtorPayment.amountInCents)
        .reduce((a, b) => a + b, 0);

      return countedAmountInCents !== this.initialTotalRealtorPayment
        ? `Yhteenlaskettu välityspalkkio ei täsmää kokonaispalkkioon. Välityspalkkio: ${this.$filters.currency(this.initialTotalRealtorPayment / 100)}. Osuudet yhteensä: ${this.$filters.currency(countedAmountInCents / 100)}` : false;
    },

    showOrganizationSelection() {
      return [
        'TRADE_REGISTER_EXTRACT',
        'MINUTES_EXTRACT',
      ].includes(this.currentDocument.documentType);
    },

    shareCertificateLocationText() {
      return this.shareLocations.find(s => s.value === this.shareLocation).text || '';
    },

    shareCertificateRequired() {
      if (this.tradeDetails.data) return false;
      if (this.shareLocation === 'ONE_OF_SELLERS_HAS_SHARE_CERTIFICATE'
        && !this.documents.some(d => d.documentType === 'SHARE_CERTIFICATE')) {
        return true;
      }
      return false;
    },

    shareInAttachments() {
      if (this.tradeDetails.data) return false;
      return this.documents.some(d => d.documentType === 'SHARE_CERTIFICATE'
      && this.shareLocation !== 'ONE_OF_SELLERS_HAS_SHARE_CERTIFICATE');
    },

    sortedDocuments() {
      if (this.documents.length === 0) {
        return [];
      }
      const docs = this.documents.filter(d => d.description === 'Liite');
      const bill = this.documents.find(d => d.description === 'Kauppakirja');
      docs.unshift(bill);
      return docs;
    },

    certificateExists() {
      return this.tradeDetails.data && this.tradeDetails.data.tradeState.shareCertificate;
    },

    signedBillAvailable() {
      return this.tradeDetails.data && this.tradeDetails.data.tradeState.signingComplete;
    },

    ownershipTransferDocumentAvailable() {
      return this.tradeDetails.data && this.tradeDetails.data.ownershipTransferPowerOfAttorney;
    },

    progress() {
      if (!this.tradeDetails.data) return 0;

      const percentages = {
        INITIATED: 5,
        SELLER_BANK_APPROVED: 15,
        BUYER_BANK_APPROVED: 15,
        INITIATOR_SIGNING_CONFIRMATION_RECEIVED: 20,
        SIGNING_STARTED: 25,
        SIGNING_COMPLETED: 60,
        BUYER_BANK_PAYMENTS_COMPLETED: 70,
        SELLER_BANK_PAYMENTS_COMPLETED: 70,
        SELLER_BANK_TRANSFERRED_SHARE: 80,
        BUYER_BANK_RECEIVED_SHARE: 95,
        COMPLETED: 100,
        CANCELLED: 0,
        MOVED_TO_MANUAL_PROCESSING: 0,
      };

      return percentages[this.tradeDetails
        .data.events[this.tradeDetails.data.events.length - 1]
        .tradePhase];
    },

    buyersPayload() {
      if (!this.property?.buyers) return [];

      if (this.tradeBuyers.length) {
        return this.tradeBuyers;
      }

      return this.property.buyers.map((b) => {
        const buyer = {
          roles: b.roles,
          bankBusinessId: b.person?.bankBusinessId,
        };

        if (b.roles.includes('ORGANIZATION')) {
          buyer.organization = b.organization;
        } else {
          buyer.person = {
            firstName: b.person.firstName,
            lastName: b.person.lastName,
            email: b.person.email,
            socialSecurityNumber: b.person.socialSecurityNumber,
          };
        }

        if (b.roles.includes('ORGANIZATION_SIGNER')) {
          buyer.businessIds = b.businessIds;
        }

        if (b.roles.includes('ORGANIZATION_SIGNER') && b.roles.length === 1) {
          delete buyer.bankBusinessId;
        }

        if (+b.person.transfertax === 1) {
          buyer.transferTax = {
            amountInCents: Math.round(this.tax(b.person) * 1000 / 10),
          };
        }
        return buyer;
      });
    },

    breadCrumbs() {
      if (!this.property) return [];

      return [
        {
          disabled: false,
          href: this.property.propertypath,
          link: true,
          text: this.property.apartment.address.streetAddress,
        }, {
          disabled: false,
          link: false,
          text: 'Sähköinen kaupankäynti',
        }];
    },

    latestStatus() {
      if (!this.tradeDetails.data) return 'Sähköistä kaupankäyntiä ei ole vielä aloitettu';

      return this.tradeDetails
        .data.events[this.tradeDetails.data.events.length - 1].displayText.fin;
    },

    detailsMissing() {
      const buyerDetailsMissing = this.property.buyers.some((b) => {
        for (const key in b) {
          if (b[key] === '') {
            return true;
          }
        }
        return false;
      });

      const sellerDetailsMissing = this.sellersPayload.some((b) => {
        for (const key in b.person) {
          if (b.person[key] === '') {
            return true;
          }
        }
        return false;
      });

      return buyerDetailsMissing || sellerDetailsMissing;
    },
  },

  watch: {
    userDetails: {
      async handler(val) {
        this.currentAgent = val;
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.$bus.$emit('SHOW_GLOBAL_LOADER', 'Haetaan tietoja DIASista');

    await this.setCurrentProperty(this.$route.params.id);

    if (+this.currentProperty.osakevaikiinteisto === 0) {
      this.$router.push({ name: 'diasRealEstate', companyId: this.$route.params.companyId, id: this.$route.params.id });
      return;
    }

    const banksResponse = await apiGet('dias/banks');

    if (!banksResponse.result) {
      this.$bus.$emit('HIDE_GLOBAL_LOADER');

      this.connectionFailure = true;
    } else {
      await this.getAgents();

      this.banks = banksResponse.result.data.values
        .map(b => ({ ...b, combName: `${b.name} (${b.groupName})` }));

      await this.getTradeDetails();

      if (!this.tradeDetails.data) {
        await this.getConfirmationSummary();

        this.getStoredBankSelections();

        this.getMortgageStatus();
      }

      this.$bus.$on('GET_DIAS_DOCUMENTS', () => {
        this.getDocuments();
      });

      this.$bus.$emit('HIDE_GLOBAL_LOADER');
    }
  },
  methods: {
    ...mapActions({
      setCurrentProperty: 'setCurrentProperty',
    }),

    log(message) {
      console.log(message);
    },

    async applyDocument() {
      this.editDocumentDialog = false;
      this.documents = this.documents.map((d) => {
        if (d.id === this.currentDocument.id) {
          return this.currentDocument;
        }

        return d;
      });

      const params = {
        id: this.currentDocument.id,
        documentType: this.currentDocument.documentType,
        estateSocialSecurityNumber: this.currentDocument.estateSocialSecurityNumber || '',
        businessId: this.currentDocument.businessId || '',
      };

      if (!this.showEstateSelection) {
        params.estateSocialSecurityNumber = '';
      }

      if (!this.showOrganizationSelection) {
        params.businessId = '';
      }

      await apiPost('dias/update-document-type', params);
    },

    goToStart() {
      this.$router.go(-1);
    },

    getCompanyName(businessId) {
      const company = this.property?.sellers.find(e => e.organization?.businessId === businessId);

      return company?.organization?.name || '';
    },

    getCompanyNameBuyers(businessId) {
      const company = this.property?.buyers.find(e => e.organization?.businessId === businessId);

      return company?.organization?.name || '';
    },

    getEstateName(estate) {
      const estateObj = this.estates.find(e => e.person.id === estate);

      if (!estateObj) return '';

      return `${estateObj.person.firstName} ${estateObj.person.lastName}`;
    },

    setAllSellersBank(bank) {
      this.property.sellers.forEach((seller) => {
        this.storePersonBank(seller.person.id, bank);
        seller.person.bankBusinessId = bank; // eslint-disable-line
      });
    },

    setAllBuyersBank(bank) {
      this.property.buyers.forEach((buyer) => {
        this.storePersonBank(buyer.person.id, bank);
        buyer.person.bankBusinessId = bank; // eslint-disable-line
      });
    },

    showLoader() {
      this.$bus.$emit('SHOW_GLOBAL_LOADER', 'Haetaan tietoja DIASista');
    },

    editDocument(document) {
      this.currentDocument = {
        ...document,
        estateSocialSecurityNumber: document.estateSocialSecurityNumber || null,
        businessId: document.businessId || null,
      };

      this.editDocumentDialog = true;
    },

    async getConfirmationSummary() {
      const response = await apiGet(`dias/confirmationsummary/${this.$route.params.id}`);
      this.property = response.result;

      this.property.sellers = this.property.sellers.map(seller => ({
        ...seller,
        realtorPaymentPerSellerInCents: this.realtyComissionAmountPerSeller(seller),
      }));

      this.property.buyers = this.property.buyers.map((buyer) => {
        if (+buyer.person.transfertax === 1) {
          return {
            ...buyer,
            transferTax:
            {
              amountInCents: Math.round(this.tax(buyer.person) * 1000 / 10),
            },
          };
        }

        return buyer;
      });

      this.getDocuments(true);
    },

    formatTimeStamp(timestamp) {
      const dateTime = new Date(timestamp);
      return `${dateTime.toLocaleDateString('fi-FI')} klo ${dateTime
        .toLocaleTimeString('fi-FI', { hour: '2-digit', minute: '2-digit' })
        .replace('.', ':')}`;
    },

    async getTradeDetails(retry = false, state = null) {
      const response = await apiGet(`dias/papertrade/${this.$route.params.id}`);

      this.tradeId = response.tradeId;

      if (response?.result?.data?.status === 'ARCHIVED') {
        this.$bus.$emit('HIDE_GLOBAL_LOADER');

        this.editable = false;

        this.archived = true;

        return;
      }

      let requiredState = true;

      if (response.success && state) {
        requiredState = state === response.result.data.tradeState.tradePhase;
      }

      if (response.success && response.result.data.status !== 'NOT_FOUND' && requiredState) {
        this.$bus.$emit('HIDE_GLOBAL_LOADER');

        this.editable = false;

        this.tradeDetails = response.result;

        this.property = {};

        this.currentAgent = this.agents
          .find(a => a.id === +this.tradeDetails.data.initiatorPersonId);

        this.property.apartment = response.result.data.apartment;

        this.property.sellers = response.result.data.sellers.map(s => ({
          person: { ...s.person, bankBusinessId: s.bankBusinessId },
          ...(s.roles ? { roles: s.roles } : {}),
          realtorPayment: s.realtorPayment,
        }));

        this.tradeSellers = response.result.data.sellers;

        this.property.buyers = response.result.data.buyers
          .map(b => (
            { ...b.person, transferTax: b.transferTax, bankBusinessId: b.bankBusinessId }));

        this.tradeBuyers = response.result.data.buyers;

        this.property.companyBankAccounts = [];

        this.property.companyBankAccounts.push({
          iban: response.result.data.realtorBankAccount.IBAN,
          bic: response.result.data.realtorBankAccount.BIC,
        });

        this.documents = [
          {
            dias_id: response.result.data.billOfSale.id,
            description: 'Kauppakirja',
            filename: response.result.data.billOfSale.description,
          },
          ...response.result.data.attachments.map(a => ({
            dias_id: a.id,
            description: 'Liite',
            filename: a.description,
          })),
        ];
      } else {
        if (retry && this.tries < 8) {
          setTimeout(() => {
            this.getTradeDetails(true, state);
          }, (this.tries * this.tries * 1000) + 1000);
          this.tries += 1;
        }

        this.tradeDetails = {};

        this.editable = true;
      }
    },

    getBankName(businessId) {
      const bank = this.banks.find(b => b.businessId === businessId);

      if (bank) {
        return `${bank.name} (${bank.groupName})`;
      }

      return businessId;
    },

    tax(buyer) {
      if (buyer.transfertax) {
        return +buyer.totalprice * (+buyer.share / +buyer.divider)
          * (this.taxDetails.varainsiirtoveroprosentti / 100) / 100;
      }

      return 0;
    },

    edit(item) {
      this.editedItem = item;

      this.editedAmountInEuros = 0;

      if (item.realtorPayment) {
        this.editedAmountInEuros = item.realtorPaymentPerSellerInCents / 100;
      }

      this.dialog = true;
    },

    realtyComissionAmountPerSeller(seller) {
      let payers = 1;

      if (this.tradeDetails.data) {
        // payers = this.property.sellers.filter(s => s.realtorPayment).length;
      } else {
        payers = this.property.sellers.filter(s => !s.doesNotPay && s.roles?.some(r => ['SIGNER', 'ORGANIZATION', 'ESTATE'].includes(r))).length;
      }

      if (seller.realtorPayment && seller.realtorPayment.amountInCents > 0 && payers > 0) {
        return Math.round(seller.realtorPayment.amountInCents / payers);
      }
      return 0;
    },

    goToTaxTransfer() {
      this.$router.push(`/${this.$route.params.companyId}/taxtransfer/${this.$route.params.id}`);
    },

    async download(document) {
      const baseURL = process.env.NODE_ENV === 'production'
        ? '/public/backend/api/v1/'
        : 'http://localhost:8888/public/backend/api/v1/';

      const options = {
        method: 'GET',
        credentials: 'include',
      };

      const docResponse = await fetch(`${baseURL}dias/download/${document.dias_id}`, options);

      const doc = await docResponse.arrayBuffer();

      download(doc, document.filename, 'application/pdf');
    },

    async getAgents() {
      const agentResponse = await apiGet('agent/getAgents');
      this.agents = agentResponse.result;
    },

    async getDocuments(doNotMerge = false) {
      const docResponse = await apiGet(`dias/documents/${this.$route.params.id}`);

      const newDocuments = docResponse.result
        .filter(document => !this.documents.map(d => d.id).includes(document.id));

      if (doNotMerge) {
        this.documents = docResponse.result;

        return;
      }

      this.documents = [...this.documents, ...newDocuments];
    },

    async deleteDocument(id) {
      await apiGet(`dias/delete/${id}`);

      this.documents = this.documents.filter(d => d.id !== id);
    },

    async sendToDias() {
      this.showConfirmation = false;

      this.$bus.$emit('SHOW_GLOBAL_LOADER');

      const sellers = this.sellersPayload.map((s) => {
        const { signingTimestamps, ...seller } = s;

        return seller;
      });

      const buyers = this.buyersPayload.map((s) => {
        const { signingTimestamps, ...buyer } = s;

        return buyer;
      });

      const billOfSale = {
        id: this.documents.find(d => d.description === 'Kauppakirja').dias_id,
        description: 'Kauppakirja',
      };

      let orderNumber = 1;

      const attachments = this.documents
        .filter(d => d.description !== 'Kauppakirja')
        .map((doc, index) => {
          const attachment = {
            id: doc.dias_id,
            description: doc.filename,
          };

          if (doc.documentType) {
            let attachmentIdentifier = ` ${index + 1}`;

            attachment.documentType = doc.documentType;

            if ([
              'ESTATE_INVENTORY_DEED',
              'ESTATE_INVENTORY_DEED_ATTACHMENT',
              'ESTATE_INVENTORY_DEED_SHAREHOLDERS_CERTIFICATION',
            ].includes(attachment.documentType) && doc.estateSocialSecurityNumber) {
              attachmentIdentifier = ` ${doc.estateSocialSecurityNumber}`;

              if (attachment.documentType === 'ESTATE_INVENTORY_DEED_ATTACHMENT') {
                if (orderNumber > 1) {
                  attachmentIdentifier = `${attachmentIdentifier} ${orderNumber}`;
                }

                orderNumber += 1;
              }
            }

            attachment.description = `${this.documentTypes
              .find(dt => dt.documentType === doc.documentType).description}${attachmentIdentifier}`;
          }

          if (doc.estateSocialSecurityNumber) {
            attachment.estateSocialSecurityNumber = doc.estateSocialSecurityNumber;
          }

          if (doc.businessId) {
            attachment.businessId = doc.businessId;
          }

          return attachment;
        });

      const { apartment } = this.property;

      delete apartment.address.kiinteistotunnus;

      const params = {
        attachments,
        requireInitiatorConfirmation: true,
        billOfSale,
        sellers,
        buyers,
        realtorBankAccount: {
          IBAN: this.property.companyBankAccounts[0].iban,
          BIC: this.property.companyBankAccounts[0].bic,
          name: this.property.companyBankAccounts[0].name,
        },
        initiatorPersonId: this.currentAgent.id,
        initiatorContactInfo: {
          email: this.currentAgent.email,
          phoneNumber: this.currentAgent.puhelin,
        },
        apartment,
        sellerShareCertificateStatus: this.shareLocation,
        tradeInitiatedTimestamp: new Date().toISOString(),
        initiatorTradeReferenceId: this.$route.params.id,
        automaticSigningProcess: this.automaticSigningProcess,
        email: this.email,
        buyersMortgageStatus: this.buyersMortgageStatus,
      };

      if (this.deadlineIso) {
        params.deadlineForSigningBillOfSale = this.deadlineIso;
      }

      const response = await apiPost(`dias/sendpapertrade/${this.$route.params.id}`, params);

      if (response.success && response.result.data.status !== 'INVALID_INPUT') {
        this.inputError = null;

        await this.getTradeDetails(true);
      } else if (response.success) {
        this.inputError = response.result.data.description.fin;

        this.$bus.$emit('HIDE_GLOBAL_LOADER');
      }
    },

    goBackToBillOfSale() {
      window.location.href = this.currentProperty.propertypath.replace('hallinta', 'kauppakirjapreview');
    },

    storePersonBank(personId, bankId) {
      localStorage.setItem(`person-bank-${personId}`, bankId);
    },

    storeMortgageStatus() {
      localStorage.setItem(`buyers-mortgage-status-${this.$route.params.id}`, this.buyersMortgageStatus);
    },

    getPersonBank(personId) {
      return localStorage.getItem(`person-bank-${personId}`) || '';
    },

    getMortgageStatus() {
      this.buyersMortgageStatus = localStorage.getItem(`buyers-mortgage-status-${this.$route.params.id}`) || 'MORTGAGE';
    },

    getStoredBankSelections() {
      this.property.sellers.forEach((seller) => {
        seller.person.bankBusinessId = this.getPersonBank(seller.person.id); // eslint-disable-line
      });

      this.property.buyers.forEach((buyer) => {
        buyer.person.bankBusinessId = this.getPersonBank(buyer.person.id); // eslint-disable-line
      });
    },

    async cancel(remotelyCancelled = false) {
      if (remotelyCancelled) {
        await apiPost(`dias/resettrade/${this.$route.params.id}`);

        this.goBackToBillOfSale();
      } else {
        this.cancelDialog = false;

        this.$bus.$emit('SHOW_GLOBAL_LOADER', 'Keskeytetään kauppa');

        await apiPost(`dias/canceltrade/${this.$route.params.id}`, { cancellationReason: this.cancelReason, initiatorPersonId: this.tradeDetails.data.initiatorPersonId });

        this.$bus.$emit('HIDE_GLOBAL_LOADER');
      }

      this.tradeDetails = {};

      await this.getConfirmationSummary();

      this.getStoredBankSelections();

      this.editable = true;
    },

    async startSigning() {
      this.cancelDialog = false;

      this.$bus.$emit('SHOW_GLOBAL_LOADER', 'Aloitetaan allekirjoitusprosessi');

      await apiPost(`dias/startsigning/${this.$route.params.id}`, { initiatorPersonId: this.tradeDetails.data.initiatorPersonId });

      await this.getTradeDetails(true, 'SIGNING_STARTED');
    },
  },
};
</script>
<style scoped>
  .v-sheet.v-card {
    border-radius:8px!important;
  }

  .helmi-font {
    font-family: 'Roboto', sans-serif !important;
    font-weight: 700;
    font-size: 13px;
  }
  .v-progress-linear__content {
    justify-content: flex-start !important;
    align-items: center !important;
  }

  .gap {
    gap: 8px;
  }
</style>
